import {
  Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter
} from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatSnackBar } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { LocalidadesService } from 'src/app/services/localidades.service';
import { Cep } from 'src/app/interfaces/cep';
import { Municipio } from 'src/app/interfaces/municipio';
import { Uf } from 'src/app/interfaces/uf';
import { Subscription, Observable } from 'rxjs';
import { startWith, map, debounceTime } from 'rxjs/operators';
import { ServerUrlService } from 'src/app/services/server-url.service';
import { MatInput } from '@angular/material/input';
import { ParametrosService } from 'src/app/services/parametros.service';
import { UserType } from 'src/app/interfaces/user';
import { VetFormComponent } from '../vet-form/vet-form.component';
import { Console } from 'console';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MM YYYY',
  },
};



@Component({
  selector: 'app-cadastro',
  templateUrl: './cadastro.component.html',
  styleUrls: ['./cadastro.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-br' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class CadastroComponent implements OnInit {
  @Input() stepper: any;
  @ViewChild('respNome') respNome: ElementRef;
  @ViewChild('respCPF') respCPF: ElementRef;
  @ViewChild('respGrau') respGrau: ElementRef;
  @ViewChild('emailInput') emailInput: ElementRef;
  @ViewChild('cpfInput') cpfInput: ElementRef;
  @Output() userLgdIn = new EventEmitter<any>();
  @Input() userRegister: any;
  nome: string;
  cpf: string;
  fone: string;
  email: string;
  senha: string;
  senhaConf: string;
  date = new FormControl();
  maxDate = new Date();
  smallScreen: boolean;
  validInputs: any;
  CPFControl = new FormControl();
  ConfirmaControl = new FormControl();
  EmailControl = new FormControl();
  CelularControl = new FormControl();

  LogradouroControl = new FormControl();
  MunicipioControl = new FormControl();
  EstadoControl = new FormControl();
  BairroControl = new FormControl();

  userData: any = {};

  action: string;
  cepHint: string;
  cepError: string;

  municipiosList: [Municipio];
  estadosList: [Uf];

  estadoRef: Subscription = null;
  municipioRef: Subscription = null;

  filteredMunicipioOptions: Observable<string[]>;
  optionsMunicipio: string[] = [];

  filteredRuaOptions: Observable<string[]>;
  optionsRua: string[] = [];

  PossuiCPFControl = new FormControl();
  // tslint:disable-next-line: no-inferrable-types
  temResponsavel: boolean = false;
  responsaveis: any = [];
  grauParentesco: any = [];

  continueForm = false;
  @ViewChild('myFone') myFone: MatInput;

  isAppVet: boolean = true;
  @ViewChild(VetFormComponent) private vetFormChild: VetFormComponent

  termosHTML: any = false
  acceptedTerms = new FormControl()

  constructor(
    private auth: AuthService,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute,
    private localidades: LocalidadesService,
    private _snackBar: MatSnackBar,
    private serverUrlService: ServerUrlService,
    private parametrosService: ParametrosService
  ) {

    // Detecta o tamanho da janela (Desktop/Mobile)
    this.smallScreen = (window.innerWidth <= 400) ? true : false;
    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small
    ]).subscribe(result => {
      this.smallScreen = result.matches;
    });

    // Get Action INS = Cadastro, UPD = Atualizar Cadastro
    if (this.route.snapshot.data.action) {
      this.action = route.snapshot.data.action;
    } else {
      this.action = 'INS';
    }

    // Get All cities
    this.municipioRef = this.localidades.municipioEnd$.subscribe(() => {
      this.municipiosList = this.localidades.getAllMunicipios();
      this.refreshCityList('');
    });

    this.filteredMunicipioOptions = this.MunicipioControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterMunicipio(value))
      );

    this.filteredRuaOptions = this.LogradouroControl.valueChanges
      .pipe(
        startWith(''),
        debounceTime(400),
        map(value => this._filterRua(value))
      );

    this.LogradouroControl.valueChanges.subscribe((val) => {
      if ((this.userData.estado && this.userData.estado.length === 2) && (this.userData.cidade && this.userData.cidade.length >= 3) ) {
        if (val.length >= 3) {
          this.localidades.searchRua(this.userData.estado, this.userData.cidade, val)
            .subscribe(
              data => {
                this.optionsRua = [];
                const myData = data;
                myData.forEach(element => {
                  if (element.logradouro) {
                    this.optionsRua.push(element.logradouro);
                  }
                });
                return this.optionsRua;
              }
            );
        }
      } else {
        this.optionsRua = [];
      }
      if (val && val.length < 3) {
        this.optionsRua = [];
      }
    });

    this.carregarGrauParentesco();

    this.userData = {
      cpf: '',
      fone: '',
      nome: '',
      sexo: '',
      email: '',
      cep: '',
      nascimento: '',
      logradouro: '',
      numero: null,
      complemento: '',
      bairro: '',
      cidade: '',
      estado: '',
      referencia: '',
      peso: 0,
      nome_social: '',
      responsaveis: []
    };

    const userString = sessionStorage.getItem('userData');
    if (this.action === 'INS') {

    } else if (userString) {
      // this.PossuiCPFControl.disable();
      // Get Info do usuário da Sessão
      this.userData = JSON.parse(userString);
      this.date.setValue(new Date(this.userData.nascimento));
      if (this.userData.responsaveis) {
        this.responsaveis = JSON.parse(this.userData.responsaveis);
      }

      if (this.responsaveis.length > 0) {
        this.temResponsavel = true;
      } else {
        this.temResponsavel = false;
      }
    }

    // Get All states
    this.estadoRef = this.localidades.ufEnd$.subscribe(() => {
      setTimeout(() => {
        this.estadosList = this.localidades.getAllUf();
        this.estadosList.sort((a: any, b: any) => {
          if (a.nome < b.nome) {
            return -1;
          }
          if (a.nome > b.nome) {
            return 1;
          }
          return 0;
        });

        if (this.userData.estado) {
          this.EstadoControl.setValue(this.userData.estado);
        }
      }, 1000);

    });

    this.EstadoControl.valueChanges.subscribe((val) => {
      if (val) {
        this.refreshCityList(val);
      }
    });

    this.appVet();
  }

  ngOnInit() {
    this.validInputs = {
      cpf: 'vazio',
      email: 'vazio'
    }
    this.checkIfHasTerms()
  }

  private checkIfHasTerms(): void {
    const termsParam = this.parametrosService.getParams('MODELO_TERMO_LGPD')
    const termosId = termsParam && termsParam.valor ? termsParam.valor : null

    if (!termosId) return
    // termosHTML
    const data = {
      id: Number(termosId)
    }

    this.parametrosService.getTermos(data).subscribe(resp => {
      this.termosHTML = resp.data[0].ModeloDocumentoValor
      this.formattedTerms = this.termosHTML
      this.formatTerms()
    })

    if(this.userData.ip && this.userData.navegador) {
      this.acceptedTerms.setValue(true)
      this.validaFormulario()
    }
  }

  vetValidation(isValid: boolean): void {
    if (!isValid) {
      this.continueForm = false
    } else {
      this.validaFormulario()
    }
  }

  private _filterMunicipio(value: string): string[] {
    const filterValue = value && value.toLowerCase();

    if (filterValue === '') {
      return [];
    }
    return this.optionsMunicipio.filter(option => option.toLowerCase().includes(filterValue));
  }

  private _filterRua(value: string): string[] {
    const filterValue = value && value.toLowerCase();

    return this.optionsRua.filter(option => option.toLowerCase().includes(filterValue));
    /*
    if (this.userData.estado.length !== 2 || this.userData.cidade.length < 3 || filterValue.length < 3) {
      return [];
    }

    this.localidades.searchRua(this.userData.estado, this.userData.cidade, filterValue)
      .subscribe(
        data => {
          this.optionsRua = [];
          const myData = data;
          myData.forEach(element => {
            if (element.logradouro) {
              this.optionsRua.push(element.logradouro);
            }
          });
          return this.optionsRua;
        }
      );
      */
  }

  private refreshCityList(filter: string) {
    let CheckCityInputed: boolean;
    CheckCityInputed = false;
    this.optionsMunicipio = [];

    if (this.municipiosList && this.municipiosList.length) {
    this.municipiosList.forEach(ele => {

      if (filter === '') {
        this.optionsMunicipio.push(ele.nome);
        CheckCityInputed = true;
      } else {
        if (filter === ele.microrregiao.mesorregiao.UF.sigla) {
          this.optionsMunicipio.push(ele.nome);
          if (this.MunicipioControl.value === ele.nome) {
            CheckCityInputed = true;
          }
        }
      }

    });
  }

  }

  onRegistrarPressed() {
    this.validaFormulario()

    if (this.continueForm === true) {

    const { date, senha } = this;
    const nascimento = date.value.toISOString().slice(0, 10);
    const newCep = this.userData && this.userData.cep && parseInt(this.userData.cep) > 0 ? parseInt(this.userData.cep) : null
    const registro: UserType = {
      nome: this.userData.nome,
      sexo: this.userData.sexo,
      cpf: this.userData.cpf,
      fone: this.userData.fone,
      nascimento,
      email: this.userData.email,
      senha: senha ? senha : '',
      tipo: 'paciente',
      cep: newCep,
      estado: this.userData.estado,
      cidade: this.userData.cidade,
      logradouro: this.userData.logradouro,
      numero: this.userData.numero,
      complemento: this.userData.complemento,
      bairro: this.userData.bairro,
      referencia: this.userData.referencia,
      responsaveis: JSON.stringify(this.responsaveis),
      nome_social: this.userData.nome_social,
      peso: this.userData.peso,
      token: '',
      id: 0,
      vet: this.isAppVet === true ? this.vetFormChild.getUserVet() : null,
      termos_aceitos: this.termosHTML && !!this.acceptedTerms
    };
    
    if (this.action === 'INS') {
      this.auth.userCadastro(registro)
        .subscribe(
          data => {
            sessionStorage.setItem('userData', JSON.stringify(data));
            this.auth.setUser(data)
            if (this.userRegister) {
              this.userLgdIn.emit(data);
            } else {
              this.router.navigate(['/' + this.serverUrlService.getName() + '/client/meus-agendamentos']);
            }
          },
          err => { window.alert(err.error.erro); }
        );
    } else if (this.action === 'UPD') {
      registro.token = this.userData.token;
      registro.id = this.userData.id;
      this.auth.userAtualiza(registro);
    }
  }
  }

  onSubmit() {
    const email = this.userData.email;
    if (email) {
      this.auth.checaEmail(email)
        .subscribe(
          data => {
            if ((data as any).encontrado) {
              if (this.action === 'UPD') {
                const myUser = JSON.parse(sessionStorage.getItem('userData'));
                if (this.userData.email !== myUser.email) {
                  this.EmailControl.setErrors({ incorrect: true });
                  this.validInputs.email = 'cadastrado';
                  setTimeout(() => {
                    this.emailInput.nativeElement.focus();
                    // this.emailInput.nativeElement.select();
                  }, 200);
                } else {
                  this.EmailControl.setErrors(null);
                  this.validInputs.email = '';
                }
              } else if (this.action === 'INS') {
                this.EmailControl.setErrors({ incorrect: true });
                this.validInputs.email = 'cadastrado';
                setTimeout(() => {
                  this.emailInput.nativeElement.focus();
                  // this.emailInput.nativeElement.select();
                }, 200);
              }
            } else {
              this.EmailControl.setErrors(null);
              this.validInputs.email = '';
            }
          },
          err => { console.error(err.error.erro); }
        );
    } else {
      this.EmailControl.setErrors(null);
    }
  }

  senhaStatus() {
    const { senha, senhaConf } = this;
    if (senha || senhaConf) {
      if (senha === senhaConf) { this.ConfirmaControl.setErrors(null); return 'igual'; }
      this.ConfirmaControl.setErrors({ incorrect: true });
      return 'dif';
    }
    this.ConfirmaControl.setErrors(null);
    return 'vazio';
  }

  onVoltarClick() {
    this.userLgdIn.emit();
  }

  onChangeCPF() {
    this.validInputs.cpf = 'editando';
    if (this.userData.cpf) {

      this.auth.validaCpf(this.userData.cpf)
        .subscribe(
          data => {
            const myUser = JSON.parse(sessionStorage.getItem('userData'));

            this.validInputs.cpf = (data as any).status;
            if (this.validInputs.cpf !== 'valido') {
              if (this.validInputs.cpf === 'cadastrado' && 
                 this.userData && this.userData.id && 
                 myUser && myUser.id &&
                 this.userData.id === myUser.id) {
                this.CPFControl.setErrors(null);
                this.PossuiCPFControl.disable();
              } else {
                this.CPFControl.setErrors({ incorrect: true });
                this.cpfInput.nativeElement.focus();
              }
            } else {
              
              if (!myUser || (myUser && myUser.hasOwnProperty('cpf') && this.userData.cpf !== myUser.cpf) ) {
                this.checkCPFCadastrado(this.userData.cpf);
              } else {
                this.validInputs.cpf = 'valido';
                this.CPFControl.setErrors(null);
              }
            }
          },
          err => { console.error(err.error.erro); }
        );
    }
  }

  onChangeCEP() {
    if (this.userData.cep.length === 8) {
      this.cepError = '';
      this.localidades.searchCep(this.userData.cep)
        .subscribe(
          data => {
            const myData: any = data;
            const myCep: Cep = myData;
            if (myCep.erro === true) {
              // CEP não localizado
              this.cepHint = 'Cep não localizado.';
              this.MunicipioControl.enable();
              this.EstadoControl.enable();
              this.BairroControl.enable();
              this.LogradouroControl.enable();
            } else {
              this.cepHint = '';
              this.userData.bairro = myCep.bairro || '';
              this.userData.cidade = myCep.localidade || '';
              this.userData.estado = myCep.uf || '';
              this.userData.logradouro = myCep.logradouro || '';

              if (myCep.localidade !== '') { this.MunicipioControl.disable(); } else { this.MunicipioControl.enable(); }
              if (myCep.uf !== '') { this.EstadoControl.disable(); } else { this.EstadoControl.enable(); }
              if (myCep.bairro !== '') { this.BairroControl.disable(); } else { this.BairroControl.enable(); }
              if (myCep.logradouro !== '') { this.LogradouroControl.disable(); } else { this.LogradouroControl.enable(); }
            }
          }
        );
    } else {
      this.cepError = 'Cep incompleto!';
      this.MunicipioControl.enable();
      this.EstadoControl.enable();
      this.BairroControl.enable();
      this.LogradouroControl.enable();
    }
  }

  checkCPFCadastrado(cpf: string) {
    this.auth.checaCpf(cpf)
      .subscribe(
        data => {
          if ((data as any).encontrado === true) {
            this.validInputs.cpf = 'cadastrado';
            this.CPFControl.setErrors({ incorrect: true });
            this.cpfInput.nativeElement.focus();
          } else {
            this.validInputs.cpf = 'valido';
            this.CPFControl.setErrors(null);
            this.PossuiCPFControl.disable();
          }
        },
        err => { console.error(err.error.erro); }
      );
  }

  formattedTerms: string

  formatTerms() {
    if(!this.termosHTML) return
  
    this.formattedTerms = this.termosHTML + ' [#PacienteEndComp]';
  
    if(this.userData.nome) this.formattedTerms = this.formattedTerms.replace('[#Paciente]', this.userData.nome)
    if(this.userData.cpf) this.formattedTerms = this.formattedTerms.replace('[#CPF]', this.userData.cpf)
    if(this.userData.sexo) this.formattedTerms = this.formattedTerms.replace('[#PacSexo]', this.userData.sexo === 'M' ? 'Masculino' : 'Feminino')
    if(this.userData.peso) this.formattedTerms = this.formattedTerms.replace('[#PacientePeso]', this.userData.peso)
    if(this.date.valid) {
      this.formattedTerms = this.formattedTerms.replace('[#PacienteIdade]', this.calculateAge(this.date.value))
    }

    this.formattedTerms = this.formattedTerms.replace('[#PacienteEndComp]', this.getFormattedAddress())
    this.formattedTerms = this.formattedTerms.replace('[#DataAtualExtenso]', this.getWrittenDate())
    this.formattedTerms = this.formattedTerms.replace(/\[#.*?\]/g, '')
  }

  calculateAge(birthDate: string) {
    const birthDateObj = new Date(birthDate);
    const today = new Date();
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDiff = today.getMonth() - birthDateObj.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
        age--;
    }
    return age.toString();
  }

  getWrittenDate() {
    const today = new Date();
    
    const months = [
        "janeiro", "fevereiro", "março", "abril", "maio", "junho",
        "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"
    ];
    
    const day = today.getDate();
    const month = months[today.getMonth()];
    const year = today.getFullYear();
    
    const writtenDate = `${day.toString().padStart(2, '0')} de ${month} de ${year}`;
    
    return writtenDate;
  }

  getFormattedAddress () {
    const { numero, complemento, bairro, cidade, estado} = this.userData
    const rua = this.LogradouroControl.value

    if(!rua || !numero || !bairro || !cidade || !estado) return ''

    return `
      ${rua}, ${numero}${complemento ? `, ${complemento}` : ''}, ${bairro} - ${cidade}/${estado}
    `
  }

  validaFormulario() {
    this.formatTerms()
    let retorno = true;
    this.continueForm = true;

    const myUser = JSON.parse(sessionStorage.getItem('userData'));

    if (this.action === 'INS') {

      if (this.temResponsavel === true) {
        if (this.validInputs.cpf === 'valido' || this.responsaveis.length > 0) {
          retorno = true;
        } else {
          retorno = false;
        }
      } else {
        if (this.validInputs.cpf !== 'valido') {
          retorno = false;
        }
      }


      if (!this.userData.email || this.validInputs.email === 'cadastrado') {
        retorno = false;
      }

      if (this.senhaStatus() !== 'igual') {
        retorno = false;
      }

    } else if (this.action === 'UPD') {

      if (this.userData.cpf !== myUser.cpf) {
        if (this.temResponsavel === true) {
          if (this.validInputs.cpf === 'valido' || this.responsaveis.length > 0) {
            retorno = true;
          } else {
            retorno = false;
          }
        } else {
          if (this.validInputs.cpf !== 'valido') {
            retorno = false;
          }
        }
      }

      if (!this.userData.email || (this.validInputs.email === 'cadastrado' && this.userData.email !== myUser.email)) {
        retorno = false;
      }

      if ((this.senhaStatus() !== 'igual' && this.senha) || (this.senhaStatus() === 'vazio' && this.senha)) {
        retorno = false;
      }

    }

    if (!this.userData.nome) {
      retorno = false;
    }

    if (!this.userData.sexo) {
      retorno = false;
    }

    if (this.userData.peso === 0) {
      retorno = false;
    }

    this.userData.fone = this.myFone.value;
    if (!this.userData.fone || this.userData.fone.length < 14) {
      this.CelularControl.setErrors({ incorrect: true });
      retorno = false;
    } else {
      this.ConfirmaControl.setErrors(null);
    }

    if (!this.date || this.date.invalid) {
      retorno = false;
    }

    // Validade de Endereco
    if (!this.userData.estado) {
      retorno = false;
    }

    if (!this.userData.cidade) {
      retorno = false;
    }

    if (!this.userData.logradouro) {
      retorno = false;
    }

    if (!this.userData.numero) {
      retorno = false;
    }

    if (!this.userData.bairro) {
      retorno = false;
    }

    if(this.isAppVet === true) {
      if (this.vetFormChild.getValidationForm() === false) {
        retorno = false;
      }
    }

    if(this.termosHTML && !this.acceptedTerms.value) {
      retorno = false
    }

    if(retorno === false) {
      this.continueForm = false;
    }
  }


  addResponsavel(nome: string, cpf: string, grau: any) {

    if (cpf !== '') {
      this.auth.validaCpf(cpf)
        .subscribe(
          data => {
            let adicionar = true;
            if (!nome) {
              adicionar = false;
            }

            if (!grau) {
              adicionar = false;
            }

            if ((data as any).status === 'valido' && adicionar === true) {
              const resp: any = {
                nome,
                cpf,
                grau
              };
              if (!Array.isArray(this.responsaveis)) {
                this.responsaveis = [];
              }
              this.responsaveis.push(resp);
              this.respNome.nativeElement.value = '';
              this.respCPF.nativeElement.value = '';

            } else {
              // Campos incompletos
              this._snackBar.open('Informe o nome, CPF válido e grau de parentesco.', 'Entendi', {
                duration: 5000
              });
            }
          });
    } else {
      this._snackBar.open('CPF não informado', 'Entendi', {
        duration: 5000
      });
    }
  }

  delResponsavel(item: any) {
    this.responsaveis = this.responsaveis.filter(ele => {
      return ele !== item;
    });
  }

  carregarGrauParentesco() {

    this.grauParentesco.push(
      { id: 1, descricao: 'Pai' },
      { id: 2, descricao: 'Mãe' },
      { id: 3, descricao: 'Tio' },
      { id: 4, descricao: 'Tia' },
      { id: 5, descricao: 'Avô' },
      { id: 6, descricao: 'Avó' },
      { id: 7, descricao: 'Outros' }
    );
  }


  private appVet(): void {
    const appVetParam = this.parametrosService.getParams('APP_VET')
    this.isAppVet = appVetParam && appVetParam.valor && appVetParam.valor === 'true' ? true : false
  }
}
